export enum SignalDirection {
  UNKNOWN = 'unknown',
  APPROACHING = 'approaching',
  RECEDING = 'receding',
}
